export default __webpack_public_path__ + "static/media/2.64921d71.png";